import { css as emotionCSS } from '@emotion/css';
import type {
  ArrayCSSInterpolation,
  InterpolationPrimitive,
} from '@emotion/serialize';
import type { Theme } from '@src/common/styles/Theme';
import { theme } from '@src/common/styles/Theme';
export type CSSInterpolation = InterpolationPrimitive | ArrayCSSInterpolation;

type Styles =
  | TemplateStringsArray
  | CSSInterpolation
  | ((theme: Theme) => CSSInterpolation);

export const css = (styles: Styles, ...args: Array<CSSInterpolation>) => {
  if (styles instanceof Function) {
    return emotionCSS(styles(theme));
  }

  if (isTemplateString(styles)) {
    return emotionCSS(styles, ...args);
  }

  return emotionCSS(styles);
};

export type { Theme };

const isTemplateString = (
  styles: TemplateStringsArray | CSSInterpolation,
): styles is TemplateStringsArray => {
  return Array.isArray(styles) && 'raw' in styles;
};
